import React, { ReactNode } from "react";
import { mattchEmoji } from "@/components/chat/message/Input/Emoji";
import { convertStringToEmoji } from "@/components/chat/utils/ddemoji";
import { stringEncode } from "@/utils/chat/index";
import ImService from "@/server/ImService";
import moment from "moment";
import { removeFirstOccurrence } from "@/utils/chat/message";

export function formatMatchContext(
  content: string,
  searchKey: string,
  matchIndex = 0
): ReactNode[] {
  if (!content) {
    return [];
  }
  if (!searchKey) {
    return [content];
  }
  const firstIndex = content.indexOf(searchKey);
  if (firstIndex >= 0) {
    const results: ReactNode[] = [];
    if (firstIndex >= 20) {
      results.push("...");
      const start = firstIndex - 12;
      results.push(content.slice(start < 0 ? 0 : start, firstIndex));
    } else {
      results.push(content.slice(0, firstIndex));
    }
    results.push(<em key={"search-keys" + matchIndex}>{searchKey}</em>);
    results.push(
      ...formatMatchContext(content.slice(firstIndex + searchKey.length), searchKey, matchIndex + 1)
    );
    return results;
  }
  return [content];
}

export function processEmoji(content: ReactNode[]) {
  let htmlStr = "";
  let htmlArr = content.map((item: any) => {
    if (typeof item === "object") {
      let { type, props } = item;
      if (type && props) {
        return `<${type}>${props.children || ""}</${type}>`;
      }
    }
    return mattchEmoji(convertStringToEmoji(stringEncode(item)));
  });
  if (htmlArr.length) {
    htmlStr = htmlArr.join("");
  }
  return htmlStr;
}

export async function searchMessage(
  params: any
): Promise<{
  message: any[];
  end: boolean;
}> {
  const limit = params?.limit || 20;
  const imService = ImService.getInstance();
  return new Promise((resolve) => {
    imService
      .search({
        ...params,
        count: limit,
        incluedRevoke: false
      })
      .then((msgs: any[]) => {
        resolve({
          end: msgs.length < limit,
          message: msgs
        });
      })
      .catch((e) => {
        resolve({
          end: true,
          message: []
        });
      });
  });
}

export async function doSearchMessage(msgs: any[], params: any): Promise<any[]> {
  const startMid = msgs.length ? msgs[msgs.length - 1]?.mid || -1 : -1;
  const { message, end } = await searchMessage({
    ...params,
    startMid
  });
  const newMsgs = [...msgs, ...message];
  if (end) {
    return newMsgs;
  }
  return doSearchMessage(newMsgs, params);
}

export function mapMessageData(rstMessages: any[]) {
  const rstData = [["姓名", "时间", "内容"]];
  if (rstMessages?.length) {
    rstMessages.forEach((item: any) => {
      let content = "";
      const tempItem = [];

      if (item.nickName) {
        tempItem.push(item.nickName);
      }

      if (item.timestamp) {
        tempItem.push(moment(item.timestamp).format("YYYY-MM-DD HH:mm:ss"));
      }
      const appName = (window as any)?._BTS_CONFIG?.REACT_APP_NAME || process.env.REACT_APP_NAME || '京办';
      switch (item.type) {
        case "text":
          content = item.content;
          if (item?.quillImage?.length) {
            content = removeFirstOccurrence(
              content,
              "【提示：查看该消息中的图片内容，需升级" + appName + "至2.3.2版本及以上】"
            );
          }
          tempItem.push(content);
          break;
        case "image":
          tempItem.push("【图片】");
          break;
        case "voice":
          tempItem.push(item.voiceType && item.voiceType === 1 ? "【对讲语音】" : "【语音】");
          break;
        case "file":
          tempItem.push("【文件】");
          break;
        case "video":
          tempItem.push("【视频】");
          break;
        default:
          tempItem.push("-");
          break;
      }

      if (tempItem.length) {
        rstData.push(tempItem);
      }
    });
  }
  return rstData;
}
